<!-- 스크린 썸네일용 뷰 -->
<template>

    <div ref="component" draggable="false" />
  
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Component_Model from '@/nextts/model/Component_Model'
import { reactive, ref } from '@vue/reactivity';
import moment from 'moment'
import { v4 as uuidv4 } from 'uuid';

export default {

  props:{
    model:{
      type:Component_Model
    },
  },

  setup(){
    const component = ref(null);
    return {component};
  },

  data:()=>({

  }),

  mounted(){
    
    this.component.style.position = "absolute";

    //컴포넌트의 크기, 위치 설정
    this.component.style.cssText += "width:"+`${this.model.width}px`+"; height:"+`${this.model.height}px`+"; transform: translateX("+`${this.model.transx}px`+") translateY("+`${this.model.transy}px`+") rotate("+`${this.model.rotate}deg`+")";    
    
    //컴포넌트의 모양(draw)
    this.updateRender();
    
  },


  methods:{

    //스크린 그리기
    updateRender(){

        
        // showlock이 true면 컴포넌트를 숨김
        if(this.model.showlock){
            this.component.style.visibility = "hidden";
            this.component.style.pointerEvents = "none";
            return;
        } else {
            this.component.style.visibility = "visible";
            this.component.style.pointerEvents = "auto";
        }


        this.component.style.backgroundColor  = "#00000000";
        this.component.style.backgroundImage  = "";
        this.component.style.whiteSpace       = "normal";
        this.component.style.overflow         = "visible";

        this.component.style.opacity          = String(this.model.opacity);
        
        //배경타입
        /*컴포넌트의 배경타입은 사용하지 않기로 함. 무조건 투명으로 나오게 처리.
        if(this.model.bgtype == 0){
            //color
            this.component.style.backgroundColor  = this.model.backgroundColor;
            this.component.style.backgroundImage  = "";
            this.component.style.backgroundRepeat = "no-repeat";
        }else if(this.model.bgtype == 1){
            //image
            this.component.style.backgroundColor  = "#00000000";
            this.component.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
            this.component.style.backgroundImage  = "url('"+this.model.backgroundImg+"')"
            this.component.style.backgroundRepeat = "no-repeat";
        }
        */

        //컴포넌트 타입
        if(this.model.component_type == Component_Model.COMPONENT_TEXT || this.model.component_type == Component_Model.COMPONENT_DATETIME){

            this.component.innerText          = this.model.text;
            this.component.style.fontFamily   = this.model.textfont;
            this.component.style.fontSize     = this.model.textsize+'px';
            this.component.style.color        = this.model.textcolor;
            this.component.style.textAlign    = this.model.texthori_align;    //left, center, right
            
            //텍스트 세로 정렬
            this.component.style.display          = "flex";
            this.component.style.flexDirection    = "column";
            this.component.style.lineHeight       = "120%";
            this.component.style.justifyContent   = this.model.texthori_align; 
            
            this.component.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.component.style.lineHeight       = this.model.lineHeight+"%"     

            //언더라인
            if(this.model.textUnderline == 0){
                this.component.style.textDecoration = "none";
            }else{
                this.component.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.component.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.component.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.component.style.fontStyle = "normal";
            }else{
                this.component.style.fontStyle = "italic";
            }

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.component.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }else{
                this.component.style.textShadow = "";
            }

            if(this.model.outline_use){
                this.component.style.webkitTextStroke = `${this.model.outline_size}px ${this.model.outline_color}`;  
            }else{
                this.component.style.webkitTextStroke = "";  
            }

            this.component.style.backgroundClip  = "";
            this.component.style.webkitBackgroundClip = "";
            this.component.style.backgroundImage = "";
            this.component.style.color = this.model.textcolor;
            this.component.style.webkitTextFillColor = this.model.textcolor;

            if(this.model.component_type == Component_Model.COMPONENT_DATETIME){
                if(this.model.date_type.length > 0){
                    this.component.innerText = moment(new Date().toString()).format(this.model.date_type);
                }
            }

            //input 텍스트처리 (더블클릭시)
            this.component.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_ARTTEXT){
            const svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            const defs = document.createElementNS(svgElement.namespaceURI, "defs");
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            const text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
            const textPathElement = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');
            svgElement.appendChild(defs);
            svgElement.appendChild(path);
            svgElement.appendChild(text);
            text.appendChild(textPathElement);
            this.component.appendChild(svgElement);      
            
            svgElement.setAttribute("width", `${this.model.width}`);
            svgElement.setAttribute("height", `${this.model.height}`);

            //휘어짐.
            //m이 소문자여야 상대좌표다. 대문자면 절대좌표임. 시작x,y 커브기준점 x,y, 종료x,종료높이 0이면 처음높이 그대로.
            path.setAttribute('d', `m 0 ${(this.model.height/2)+(this.model.textsize/2)+this.model.text_offsetverti} q ${this.model.width/2}, ${this.model.text_arc} ${this.model.width}, 0`)
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke', 'red');
            path.setAttribute('id', 'testra');

            text.style.fontFamily = this.model.textfont;
            text.style.fontSize = `${this.model.textsize}px`;
            text.style.textAlign    = this.model.texthori_align;    //left, center, right

            //텍스트 세로 정렬
            text.style.display          = "flex";
            text.style.flexDirection    = "column";
            text.style.lineHeight       = "120%";
            text.style.justifyContent   = this.model.textverti_align;       //top, center, end

            text.style.letterSpacing    = this.model.letterSpacing+"px" 
            text.style.lineHeight       = this.model.lineHeight+"%"     

            if(this.model.color_type == "color"){
                text.style.fill       = this.model.textcolor;

            }else if(this.model.color_type == "gradient"){

                //하위 효과 초기화
                while (this.defs && this.defs.firstChild) {
                    this.defs.removeChild(this.defs.firstChild);
                }                
                
                // SVGLinearGradientElement 타입으로 linearGradient 요소 생성
                if(this.model.gradient.type == "linear"){

                    //linear
                    const linearGradient = document.createElementNS(svgElement.namespaceURI, "linearGradient");
                    const gradient_id = uuidv4();
                    linearGradient.setAttribute("id", `${gradient_id}`);
                    linearGradient.setAttribute("gradientTransform", `rotate(${Number(this.model.gradient.degree)-90})`);
                    linearGradient.setAttribute("gradientUnits", "userSpaceOnUse");
                    // SVGStopElement 타입으로 첫 번째 stop 요소 생성
                    for(const point of this.model.gradient.points){
                        const stop = document.createElementNS(svgElement.namespaceURI, "stop");
                        stop.setAttribute("offset", `${point.left}%`);
                        stop.setAttribute("style", `stop-color:rgb(${point.red},${point.green},${point.blue});stop-opacity:${point.alpha}`);
                        linearGradient.appendChild(stop);
                    }
    
                    // 요소들을 조립
                    defs.appendChild(linearGradient);
                    text.style.fill       = `url(#${gradient_id})`;

                }else{
                    //radial
                    const radialGradient = document.createElementNS(svgElement.namespaceURI, "radialGradient");
                    const gradient_id = uuidv4();
                    radialGradient.setAttribute("id", `${gradient_id}`);
                    radialGradient.setAttribute("cx", "50%");
                    radialGradient.setAttribute("cy", "50%");
                    radialGradient.setAttribute("r", "10%");
                    // SVGStopElement 타입으로 첫 번째 stop 요소 생성
                    for(const point of this.model.gradient.points){
                        const stop = document.createElementNS(svgElement.namespaceURI, "stop");
                        stop.setAttribute("offset", `${point.left}%`);
                        stop.setAttribute("style", `stop-color:rgb(${point.red},${point.green},${point.blue});stop-opacity:${point.alpha}`);
                        radialGradient.appendChild(stop);
                    }
                    // 요소들을 조립
                    defs.appendChild(radialGradient);
                    text.style.fill = `url(#${gradient_id})`;
                }
                
            }else if(this.model.color_type == "image"){
                //console.log("image...");
            }

            //외각선
            if(this.model.outline_use){ 
                text.style.stroke = `${this.model.outline_color}`;
                text.style.strokeWidth = `${this.model.outline_size}`;
                text.style.strokeDasharray = `${this.model.outline_dash1},${this.model.outline_dash2}`;
                text.style.strokeDashoffset = `${this.model.outline_offset}`;
            }else{
                text.style.stroke = "";
                text.style.strokeWidth = "";
            }             

            //언더라인
            if(this.model.textUnderline == 0){
                text.style.textDecoration = "none";
            }else{
                text.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                text.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                text.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                text.style.fontStyle = "normal";
            }else{
                text.style.fontStyle = "italic";
            }


            //input 텍스트처리 (더블클릭시)
            //this.contentEditable = "true";

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                //this.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }else{
                //this.style.textShadow = "";
            }

            //anchor가 중앙이면 x좌표를 중앙으로 맞춤.
            if(this.model.texthori_align == "left"){
                text.setAttribute("x","0%");
                text.setAttribute("text-anchor","start");
            }else if(this.model.texthori_align == "center"){
                text.setAttribute("x","50%");
                text.setAttribute("text-anchor","middle");
            }else if(this.model.texthori_align == "right"){
                text.setAttribute("x","100%");
                text.setAttribute("text-anchor","end");
            }
            
            if(this.model.textverti_align == "top"){
                text.setAttribute("y","0%");
            }else if(this.model.texthori_align == "center"){
                text.setAttribute("y","50%");
            }else if(this.model.texthori_align == "end"){
                text.setAttribute("y","100%");
            }
            textPathElement.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#testra');
            textPathElement.setAttribute('startOffset', `${this.model.text_offset}`);
            textPathElement.textContent = this.model.text;

        }else if(this.model.component_type == Component_Model.COMPONENT_IMAGE){
            
            this.component.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
            this.component.style.backgroundColor  = "#00000000";
            this.component.style.backgroundRepeat = "no-repeat";
            
            if(this.model.image != null && this.model.image != undefined && this.model.image.length > 0){
                if(this.model.image.toLowerCase().startsWith("http")){
                    this.component.style.backgroundImage  = "url('"+this.model.image+"')"
                }else{
                    this.component.style.backgroundImage  = `url(${this.model.image})`;
                }
            }
            
            this.component.style.backgroundRepeat = "no-repeat";

            //border-radius 처리
            // 개별 border radius 값이 설정되어 있는지 확인
            const hasSeparateRadius = this.model.border_radius_tl > 0 || 
                                    this.model.border_radius_tr > 0 || 
                                    this.model.border_radius_bl > 0 || 
                                    this.model.border_radius_br > 0;
            
            if (hasSeparateRadius) {
                // 개별 border radius 적용 (top-left, top-right, bottom-right, bottom-left 순서)
                this.component.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                // 전체 border radius 적용
                this.component.style.borderRadius = `${this.model.border_radius}px`;
            }

            //input 텍스트처리 (더블클릭시)
            this.component.contentEditable = "false";
            this.component.innerText = "";

            //shadow 처리
            if(this.model.shadow_use){
                this.component.style.filter = `drop-shadow(${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color})`;
            }else{
                this.component.style.filter = "";
            }

            //마스크 처리 - 테스트로 여기에 빼놨어, 모두 마스크 처리가 되긴 하네
            if(this.model.mask_use){
                this.component.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.component.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.component.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.component.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.component.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.component.style.webkitMaskImage = "";    
                }
            }else{
                this.component.style.webkitMaskImage = "";
                this.component.style.webkitMaskPosition = "";
                this.component.style.webkitMaskSize = "";
            }


        }else if(this.model.component_type == Component_Model.COMPONENT_TEXTSWITCHER){

            if(this.model.textswitcher_list != null && this.model.textswitcher_list.length > 0){
                this.component.innerText          = this.model.textswitcher_list[0];
            }else{
                this.component.innerText          = "입력된 텍스트가 없습니다.";
            }

            this.component.style.fontFamily   = this.model.textfont;
            this.component.style.fontSize     = this.model.textsize+'px';
            this.component.style.color        = this.model.textcolor;
            this.component.style.textAlign    = this.model.texthori_align;    //left, center, right
            
            //텍스트 세로 정렬
            this.component.style.display          = "flex";
            this.component.style.flexDirection    = "column";
            this.component.style.lineHeight       = "120%";
            this.component.style.justifyContent   = this.model.texthori_align; 
            
            this.component.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.component.style.lineHeight       = this.model.lineHeight+"%"     

            //언더라인
            if(this.model.textUnderline == 0){
                this.component.style.textDecoration = "none";
            }else{
                this.component.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.component.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.component.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.component.style.fontStyle = "normal";
            }else{
                this.component.style.fontStyle = "italic";
            }

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.component.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }

            if(this.model.outline_use){
                this.component.style.webkitTextStroke = `${this.model.outline_size}px ${this.model.outline_color}`;  
            }

            //input 텍스트처리 (더블클릭시)
            this.component.contentEditable = "false";

        }else if(this.model.component_type == Component_Model.COMPONENT_IMAGESWITCHER){
            
            this.component.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
            this.component.style.backgroundColor  = "#00000000";
            this.component.style.backgroundRepeat = "no-repeat";

            if(this.model.imgswitcher_list != null && this.model.imgswitcher_list.length > 0){
                this.component.style.backgroundImage  = `url(${this.model.imgswitcher_list[0]})`;
            }

            //border-radius 처리
            // 개별 border radius 값이 설정되어 있는지 확인
            const hasSeparateRadiusImageSwitcher = this.model.border_radius_tl > 0 || 
                                                  this.model.border_radius_tr > 0 || 
                                                  this.model.border_radius_bl > 0 || 
                                                  this.model.border_radius_br > 0;
            
            if (hasSeparateRadiusImageSwitcher) {
                // 개별 border radius 적용 (top-left, top-right, bottom-right, bottom-left 순서)
                this.component.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                // 전체 border radius 적용
                this.component.style.borderRadius = `${this.model.border_radius}px`;
            }

            //input 텍스트처리 (더블클릭시)
            this.component.contentEditable = "false";
            this.component.innerText = "";


            //마스크 처리 - 테스트로 여기에 빼놨어, 모두 마스크 처리가 되긴 하네
            if(this.model.mask_use){
                this.component.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.component.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.component.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.component.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.component.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.component.style.webkitMaskImage = "";    
                }
            }else{
                this.component.style.webkitMaskImage = "";
                this.component.style.webkitMaskPosition = "";
                this.component.style.webkitMaskSize = "";
            }


        }else if(this.model.component_type == Component_Model.COMPONENT_COLOR){

            if(this.model.color_type == "color"){
                this.component.style.backgroundColor  = this.model.backgroundColor;
            }else if(this.model.color_type == "gradient"){
                this.component.style.background       = this.model.backgroundColor;
            }

            //border-radius 처리
            // 개별 border radius 값이 설정되어 있는지 확인
            const hasSeparateRadiusColor = this.model.border_radius_tl > 0 || 
                                          this.model.border_radius_tr > 0 || 
                                          this.model.border_radius_bl > 0 || 
                                          this.model.border_radius_br > 0;
            
            if (hasSeparateRadiusColor) {
                // 개별 border radius 적용 (top-left, top-right, bottom-right, bottom-left 순서)
                this.component.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                // 전체 border radius 적용
                this.component.style.borderRadius = `${this.model.border_radius}px`;
            }
            //외각선
            if(this.model.outline_use){ 
                this.component.style.border = `${this.model.outline_size}px solid ${this.model.outline_color}`;
            }else{
                this.component.style.border = "";
            }             

            this.component.style.backgroundRepeat = "no-repeat";
            this.component.innerText              = "";

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.component.style.boxShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }

            //마스크 처리 - 테스트로 여기에 빼놨어, 모두 마스크 처리가 되긴 하네
            if(this.model.mask_use){
                this.component.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.component.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.component.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.component.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.component.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.component.style.webkitMaskImage = "";    
                }
            }else{
                this.component.style.webkitMaskImage = "";
                this.component.style.webkitMaskPosition = "";
                this.component.style.webkitMaskSize = "";
            }



        }else if(this.model.component_type == Component_Model.COMPONENT_SHAPE){
            
            // Shape 렌더링 (썸네일용)
            this.createShapePreview();
            
        }else if(this.model.component_type == Component_Model.COMPONENT_SVG){
            
            this.loadSVGPreview();
            
            //border-radius 처리
            const hasSeparateRadius = this.model.border_radius_tl > 0 || 
                                    this.model.border_radius_tr > 0 || 
                                    this.model.border_radius_bl > 0 || 
                                    this.model.border_radius_br > 0;
            
            if (hasSeparateRadius) {
                this.component.style.borderRadius = `${this.model.border_radius_tl}px ${this.model.border_radius_tr}px ${this.model.border_radius_br}px ${this.model.border_radius_bl}px`;
            } else {
                this.component.style.borderRadius = `${this.model.border_radius}px`;
            }

            //shadow 처리
            if(this.model.shadow_use){
                this.component.style.filter = `drop-shadow(${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color})`;
            }else{
                this.component.style.filter = "";
            }

        }else if(this.model.component_type == Component_Model.COMPONENT_MOVIE){
            this.component.style.backgroundColor  = "black";

            if(this.model.image != null && this.model.image != undefined && this.model.image.length > 0){
                //썸네일을 컴포넌트 영역에 꽉차게 (이미지 컴포넌트와 동일 방식)
                this.component.style.backgroundSize   = this.model.width + "px " + this.model.height + "px";
                this.component.style.backgroundPosition = "left top";
                if(this.model.image.toLowerCase().startsWith("http")){
                    this.component.style.backgroundImage  = "url('"+this.model.image+"')"
                }else{
                    this.component.style.backgroundImage  = `url(${this.model.image})`;
                }
            }else{
                const imgPath = require('@/assets/playlogo.png');
                this.component.style.backgroundImage  = `url(${imgPath})`
                this.component.style.backgroundSize   = "30%";
                this.component.style.backgroundPosition = "center";
            }
            
            this.component.style.backgroundRepeat = "no-repeat";
            this.component.style.color            = "white";
            this.component.innerText              = "";
            this.component.style.textAlign        = "center";    
            this.component.style.display          = "flex";
            this.component.style.flexDirection    = "column";
            this.component.style.lineHeight       = "120%";
            this.component.style.justifyContent   = "center";


            //마스크 처리 - 테스트로 여기에 빼놨어, 모두 마스크 처리가 되긴 하네
            if(this.model.mask_use){
                this.component.style.webkitMaskPosition   = `${this.model.mask_left}% ${this.model.mask_top}%`;
                this.component.style.webkitMaskSize       = `${this.model.mask_width}% ${this.model.mask_height}%`;
                if(this.model.mask_repeat){
                    this.component.style.webkitMaskRepeat = "repeat";    
                }else{
                    this.component.style.webkitMaskRepeat = "no-repeat";    
                }
                if(this.model.mask_image.length > 0){
                    //https://cdn.icon-icons.com/icons2/692/PNG/512/seo-social-web-network-internet_132_icon-icons.com_61506.png
                    this.component.style.webkitMaskImage = `url(${this.model.mask_image})`;
                }else{
                    this.component.style.webkitMaskImage = "";    
                }
            }else{
                this.component.style.webkitMaskImage = "";
                this.component.style.webkitMaskPosition = "";
                this.component.style.webkitMaskSize = "";
            }


        }else if(this.model.component_type == Component_Model.COMPONENT_YOUTUBE){
            this.component.style.backgroundColor  = "black";

            const imgPath = require('@/assets/youtubelogo.png');
            this.component.style.backgroundImage  = `url(${imgPath})`
            this.component.style.backgroundSize   = "50%";
            this.component.style.backgroundPosition = "center";

            this.component.style.backgroundRepeat = "no-repeat";

            this.component.style.color            = "white";
            this.component.innerText              = "";
            this.component.style.textAlign        = "center";    
            this.component.style.display          = "flex";
            this.component.style.flexDirection    = "column";
            this.component.style.lineHeight       = "120%";
            this.component.style.justifyContent   = "center";

        }else if(this.model.component_type == Component_Model.COMPONENT_WEBVIEW){
            this.component.style.backgroundColor  = "black";
            const imgPath = require('@/assets/homelogo.png');
            this.component.style.backgroundImage  = `url(${imgPath})`
            this.component.style.backgroundSize   = "30%";
            this.component.style.backgroundPosition = "center";
            this.component.style.backgroundRepeat = "no-repeat";

            this.component.style.color            = "white";
            this.component.innerText              = "";
            this.component.style.textAlign        = "center";    
            this.component.style.display          = "flex";
            this.component.style.flexDirection    = "column";
            this.component.style.lineHeight       = "120%";
            this.component.style.justifyContent   = "center";

        }else if(this.model.component_type == Component_Model.COMPONENT_SOUND){
            //썸네일에 나오지 말아야 한다.
            
        }else if(this.model.component_type == Component_Model.COMPONENT_API){
            //썸네일에 나오지 말아야 한다.

        }else if(this.model.component_type == Component_Model.COMPONENT_DATALOAD){
            //썸네일에 나오지 말아야 한다.

        }else if(this.model.component_type == Component_Model.COMPONENT_TEXT_SCROLL){

            this.component.innerText          = this.model.text;
            this.component.style.fontFamily   = this.model.textfont;
            this.component.style.fontSize     = this.model.textsize+'px';
            this.component.style.color        = this.model.textcolor;
            this.component.style.textAlign    = "left";    //left, center, right
            
            //텍스트 줄 바꿈 없음
            this.component.style.whiteSpace       = "nowrap";
            this.component.style.overflow         = "hidden";

            //텍스트 세로 정렬
            this.component.style.display          = "flex";
            this.component.style.flexDirection    = "column";
            this.component.style.lineHeight       = "120%";
            this.component.style.justifyContent   = "center"; 
            
            this.component.style.letterSpacing    = this.model.letterSpacing+"px" 
            this.component.style.lineHeight       = this.model.lineHeight+"%"     

            //언더라인
            if(this.model.textUnderline == 0){
                this.component.style.textDecoration = "none";
            }else{
                this.component.style.textDecoration = "underline";
            }
            
            //볼드
            if(this.model.textBold == 0){
                this.component.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "normal" : this.model.font_weight;
            }else{
                this.component.style.fontWeight = this.model.font_weight == null || this.model.font_weight.length == 0 ? "bold" : this.model.font_weight;
            }

            //이탤릭
            if(this.model.textItalic == 0){
                this.component.style.fontStyle = "normal";
            }else{
                this.component.style.fontStyle = "italic";
            }

            //그림자 우측, 아래, 블러범위, 색상
            if(this.model.shadow_use){
                this.component.style.textShadow = `${this.model.shadow_hori}px ${this.model.shadow_verti}px ${this.model.shadow_blur}px ${this.model.shadow_color}`;    
            }

            if(this.model.outline_use){
                this.component.style.webkitTextStroke = `${this.model.outline_size}px ${this.model.outline_color}`;  
            }

            //input 텍스트처리 (더블클릭시)
            this.component.contentEditable = "false";

        }
        



    },

    createShapePreview(){
        if(!this.model) return;

        // Play_Shape와 동일한 SVG 렌더링 로직 사용 (간소화된 버전)
        const svgContent = this.generateShapePreviewSVG();
        this.component.innerHTML = svgContent;
        
        // HTML 스타일 초기화
        this.component.style.background = '';
        this.component.style.clipPath = '';
        this.component.style.opacity = '';
    },

    generateShapePreviewSVG() {
        if(!this.model) return "";

        const width = this.model.width;
        const height = this.model.height;
        const fillType = this.model.shape_fill_type || "color";
        const fillColor = this.model.shape_fill_color || "#3B82F6";
        const fillImage = this.model.shape_fill_image || "";
        const fillAlpha = this.model.shape_fill_alpha !== undefined ? this.model.shape_fill_alpha : 1.0;
        const strokeColor = this.model.shape_stroke_color || "#1E40AF";
        const strokeAlpha = this.model.shape_stroke_alpha !== undefined ? this.model.shape_stroke_alpha : 1.0;
        const strokeWidth = this.model.shape_stroke_width || 0;

        // RGBA 색상 생성 함수
        const hexToRgba = (hex, alpha) => {
            const r = parseInt(hex.slice(1, 3), 16);
            const g = parseInt(hex.slice(3, 5), 16);
            const b = parseInt(hex.slice(5, 7), 16);
            return `rgba(${r}, ${g}, ${b}, ${alpha})`;
        };

        // Fill 설정 - 색상, 그라데이션, 이미지
        let finalFillColor;
        let defsContent = "";
        
        if (fillType === "image" && fillImage) {
            const patternId = this.generateUniqueIdPreview('image-pattern');
            const imageFit = this.model.shape_image_fit || "cover";
            const imagePositionX = this.model.shape_image_position_x !== undefined ? this.model.shape_image_position_x : 50;
            const imagePositionY = this.model.shape_image_position_y !== undefined ? this.model.shape_image_position_y : 50;
            const imageScale = this.model.shape_image_scale !== undefined ? this.model.shape_image_scale : 100;
            const imageRepeat = this.model.shape_image_repeat || false;

            // 이미지 크기 및 위치 계산
            const scaleRatio = imageScale / 100;
            const imageWidth = width * scaleRatio;
            const imageHeight = height * scaleRatio;
            const imageX = (width - imageWidth) * (imagePositionX / 100);
            const imageY = (height - imageHeight) * (imagePositionY / 100);

            // preserveAspectRatio 설정
            let preserveAspectRatio = "xMidYMid slice";
            switch(imageFit) {
                case "cover":
                    preserveAspectRatio = "xMidYMid slice";
                    break;
                case "contain":
                    preserveAspectRatio = "xMidYMid meet";
                    break;
                case "fill":
                    preserveAspectRatio = "none";
                    break;
                case "none":
                    preserveAspectRatio = "none";
                    break;
            }

            // 패턴 크기 설정 (반복용)
            const patternWidth = imageRepeat ? (imageWidth / width) : 1;
            const patternHeight = imageRepeat ? (imageHeight / height) : 1;

            defsContent = `<defs>
                <pattern id="${patternId}" patternUnits="objectBoundingBox" 
                         width="${patternWidth}" height="${patternHeight}">
                    <image href="${fillImage}" 
                           x="${imageX}" y="${imageY}" 
                           width="${imageWidth}" height="${imageHeight}" 
                           preserveAspectRatio="${preserveAspectRatio}" 
                           opacity="${fillAlpha}"/>
                </pattern>
            </defs>`;
            finalFillColor = `url(#${patternId})`;
        } else if (fillType === "gradient") {
            // CSS 그라데이션을 SVG 그라데이션으로 변환
            const gradientId = this.generateUniqueIdPreview('gradient');
            const parsedGradient = this.parseCSSGradientPreview(fillColor);
            
            if (parsedGradient) {
                const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                let gradientAttrs = '';
                
                if (parsedGradient.type === 'radial') {
                    gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                } else {
                    // 선형 그라데이션 각도 처리
                    const angle = parsedGradient.angle || 180;
                    const radians = ((angle - 90) * Math.PI) / 180;
                    const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                    const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                    const x2 = 50 + 50 * Math.cos(radians);
                    const y2 = 50 + 50 * Math.sin(radians);
                    gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                }
                
                let gradientStops = '';
                parsedGradient.stops.forEach(stop => {
                    gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}" stop-opacity="${fillAlpha}"/>`;
                });
                
                defsContent = `<defs>
                    <${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                        ${gradientStops}
                    </${gradientType}>
                </defs>`;
                finalFillColor = `url(#${gradientId})`;
            } else {
                finalFillColor = hexToRgba(fillColor, fillAlpha);
            }
        } else {
            // 일반 색상 처리 - alpha 값 적용
            if (typeof fillColor === 'string' && fillColor.startsWith('#') && fillColor.length === 9) {
                // 8자리 hex 색상 (alpha 포함)
                const r = parseInt(fillColor.slice(1, 3), 16) || 0;
                const g = parseInt(fillColor.slice(3, 5), 16) || 0;
                const b = parseInt(fillColor.slice(5, 7), 16) || 0;
                const a = parseInt(fillColor.slice(7, 9), 16) / 255;
                finalFillColor = `rgba(${r}, ${g}, ${b}, ${a})`;
            } else {
                finalFillColor = hexToRgba(fillColor, fillAlpha);
            }
        }
        
        // 테두리 색상 처리 (단색/그라데이션)
        let finalStrokeColor = 'none';
        if (strokeWidth > 0) {
            const strokeType = this.model.shape_stroke_type || "color";
            
            if (strokeType === "gradient") {
                // 그라데이션 처리
                const gradientId = this.generateUniqueIdPreview('stroke-gradient');
                const parsedGradient = this.parseCSSGradientPreview(strokeColor);
                
                if (parsedGradient) {
                    const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                    let gradientAttrs = '';
                    
                    if (parsedGradient.type === 'radial') {
                        gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                    } else {
                        // 선형 그라데이션 각도 처리
                        const angle = parsedGradient.angle || 180;
                        const radians = ((angle - 90) * Math.PI) / 180;
                        const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                        const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                        const x2 = 50 + 50 * Math.cos(radians);
                        const y2 = 50 + 50 * Math.sin(radians);
                        gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                    }
                    
                    let gradientStops = '';
                    parsedGradient.stops.forEach(stop => {
                        gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                    });
                    
                    const strokeGradientDef = `<${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                        ${gradientStops}
                    </${gradientType}>`;
                    
                    // 기존 defsContent에 추가
                    if (defsContent.includes('<defs>')) {
                        defsContent = defsContent.replace('</defs>', `${strokeGradientDef}</defs>`);
                    } else {
                        defsContent = `<defs>${strokeGradientDef}</defs>`;
                    }
                    
                    finalStrokeColor = `url(#${gradientId})`;
                } else {
                    finalStrokeColor = hexToRgba(strokeColor, strokeAlpha);
                }
            } else {
                finalStrokeColor = strokeColor;
            }
        }

        let shapeElement = "";
        const strokeOpacityAttr = this.model.shape_stroke_type === "gradient" ? "" : ` stroke-opacity="${strokeAlpha}"`;
        
        switch(this.model.shape_type) {
            case "rectangle":
                const rectWidth = Math.max(0, width - strokeWidth);
                const rectHeight = Math.max(0, height - strokeWidth);
                
                // 각 모서리별 둥글기 체크
                const baseRadius = this.model.shape_corner_radius || 0;
                const tl = this.model.shape_corner_radius_tl !== undefined ? this.model.shape_corner_radius_tl : baseRadius;
                const tr = this.model.shape_corner_radius_tr !== undefined ? this.model.shape_corner_radius_tr : baseRadius;
                const bl = this.model.shape_corner_radius_bl !== undefined ? this.model.shape_corner_radius_bl : baseRadius;
                const br = this.model.shape_corner_radius_br !== undefined ? this.model.shape_corner_radius_br : baseRadius;
                
                const hasSeparateRadius = tl > 0 || tr > 0 || bl > 0 || br > 0;
                
                if (hasSeparateRadius) {
                    // path를 사용해서 각 모서리별 둥글기 적용
                    const pathData = this.generateRectanglePathPreview(strokeWidth/2, strokeWidth/2, rectWidth, rectHeight, tl, tr, bl, br);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // 기본 rect 사용 (호환성)
                    const rx = this.model.shape_corner_radius || 0;
                    shapeElement = `<rect x="${strokeWidth/2}" y="${strokeWidth/2}" 
                                        width="${rectWidth}" height="${rectHeight}" 
                                        rx="${rx}" ry="${rx}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "circle":
                // 타원(Ellipse) - 너비와 높이에 맞춰 그리기
                const radiusX = Math.max(0, (width - strokeWidth) / 2);
                const radiusY = Math.max(0, (height - strokeWidth) / 2);
                const cx = width / 2;
                const cy = height / 2;
                
                // 원 제어 속성 기본값 설정
                const startAngle = this.model.circle_start_angle !== undefined ? this.model.circle_start_angle : 0;
                const endAngle = this.model.circle_end_angle !== undefined ? this.model.circle_end_angle : 360;
                const innerRadiusRatio = this.model.circle_inner_radius !== undefined ? this.model.circle_inner_radius : 0;
                
                // 완전한 타원인지 확인
                const isFullEllipse = (endAngle - startAngle) % 360 === 0;
                const isDonut = innerRadiusRatio > 0;
                
                if (isFullEllipse && !isDonut) {
                    // 기본 완전한 타원 (ellipse 태그 사용)
                    shapeElement = `<ellipse cx="${cx}" cy="${cy}" rx="${radiusX}" ry="${radiusY}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // Arc, Pie, Donut을 위한 path 생성 (타원 기준)
                    const pathData = this.generateEllipsePathPreview(cx, cy, radiusX, radiusY, startAngle, endAngle, innerRadiusRatio);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "polygon":
                const sides = this.model.polygon_sides || 5;
                const cornerRadius = this.model.polygon_corner_radius || 0;
                const innerRadius = this.model.polygon_inner_radius || 0;
                
                if (cornerRadius > 0) {
                    // 모서리 둥글기가 있는 경우 path 사용
                    const pathData = this.generatePolygonPathPreview(width, height, sides, strokeWidth, cornerRadius, innerRadius);
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                } else {
                    // 기본 polygon 사용
                    const polygonPoints = this.generatePolygonPointsPreview(width, height, sides, strokeWidth, innerRadius);
                    shapeElement = `<polygon points="${polygonPoints}"
                                        fill="${finalFillColor}" 
                                        stroke="${finalStrokeColor}" 
                                        stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
                }
                break;
                
            case "line":
                // 선 그리기
                const lineThickness = this.model.line_thickness || 2;
                const lineColorType = this.model.line_color_type || "color";
                const lineColor = this.model.line_color || "#000000";
                const lineAlpha = this.model.line_alpha !== undefined ? this.model.line_alpha : 1.0;
                const startCap = this.model.line_start_cap || "round";
                const endCap = this.model.line_end_cap || "round";
                
                let finalLineColor;
                
                if (lineColorType === "gradient") {
                    // 그라데이션 처리
                    const gradientId = this.generateUniqueIdPreview('gradient');
                    const parsedGradient = this.parseCSSGradientPreview(lineColor);
                    
                    if (parsedGradient) {
                        const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                        let gradientAttrs = '';
                        
                        if (parsedGradient.type === 'radial') {
                            gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                        } else {
                            // 선형 그라데이션 각도 처리
                            const angle = parsedGradient.angle || 180;
                            const radians = ((angle - 90) * Math.PI) / 180;
                            const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                            const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                            const x2 = 50 + 50 * Math.cos(radians);
                            const y2 = 50 + 50 * Math.sin(radians);
                            gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                        }
                        
                        let gradientStops = '';
                        parsedGradient.stops.forEach(stop => {
                            gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                        });
                        
                        defsContent = `<defs>
                            <${gradientType} id="${gradientId}" ${gradientAttrs} gradientUnits="userSpaceOnUse">
                                ${gradientStops}
                            </${gradientType}>
                        </defs>`;
                        finalLineColor = `url(#${gradientId})`;
                    } else {
                        finalLineColor = lineColor;
                    }
                } else {
                    finalLineColor = lineColor;
                }
                
                // 선의 시작점과 끝점 (컴포넌트 영역 전체를 가로지르는 수평선)
                const x1 = lineThickness / 2;
                const y1 = height / 2;
                const x2 = width - lineThickness / 2;
                const y2 = height / 2;
                
                // 그라데이션일 때는 opacity 없이, 단색일 때는 opacity 적용
                const opacityAttr = lineColorType === "gradient" ? "" : ` opacity="${lineAlpha}"`;
                
                // 시작점과 끝점이 같으면 기본 line 엘리먼트 사용
                if (startCap === endCap) {
                    shapeElement = `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"
                                        stroke="${finalLineColor}"
                                        stroke-width="${lineThickness}"
                                        stroke-linecap="${startCap}"${opacityAttr}/>`;
                } else {
                    // 시작점과 끝점이 다르면 path로 그리기
                    const halfThickness = lineThickness / 2;
                    
                    // 기본 라인 경로
                    let pathData = `M ${x1} ${y1} L ${x2} ${y2}`;
                    
                    // 시작점 캡 추가
                    if (startCap === "round") {
                        pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x1} ${y1} L ${x2} ${y2}`;
                    }
                    
                    // 끝점 캡 추가
                    if (endCap === "round") {
                        if (startCap === "round") {
                            pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x2} ${y2 + halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x2} ${y2 - halfThickness} L ${x1} ${y1 - halfThickness} Z`;
                        } else {
                            pathData = `M ${x1} ${y1 - halfThickness} L ${x2} ${y2 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x2} ${y2 + halfThickness} L ${x1} ${y1 + halfThickness} Z`;
                        }
                    } else {
                        // butt 끝점인 경우
                        if (startCap === "round") {
                            pathData = `M ${x1} ${y1 - halfThickness} A ${halfThickness} ${halfThickness} 0 0 1 ${x1} ${y1 + halfThickness} L ${x2} ${y2 + halfThickness} L ${x2} ${y2 - halfThickness} Z`;
                        } else {
                            // 둘 다 butt인 경우는 위에서 처리됨
                            pathData = `M ${x1} ${y1 - halfThickness} L ${x2} ${y2 - halfThickness} L ${x2} ${y2 + halfThickness} L ${x1} ${y1 + halfThickness} Z`;
                        }
                    }
                    
                    shapeElement = `<path d="${pathData}"
                                        fill="${finalLineColor}"${opacityAttr}/>`;
                }
                break;
                
            default:
                // 기본값은 사각형
                const defaultWidth = Math.max(0, width - strokeWidth);
                const defaultHeight = Math.max(0, height - strokeWidth);
                shapeElement = `<rect x="${strokeWidth/2}" y="${strokeWidth/2}" 
                                    width="${defaultWidth}" height="${defaultHeight}" 
                                    fill="${finalFillColor}" 
                                    stroke="${finalStrokeColor}" 
                                    stroke-width="${strokeWidth}"${strokeOpacityAttr}/>`;
        }

        return `<svg xmlns="http://www.w3.org/2000/svg" 
                    width="100%" height="100%" 
                    viewBox="0 0 ${width} ${height}">
                    ${defsContent}
                    ${shapeElement}
                </svg>`;
    },

    generatePolygonPointsPreview(width, height, sides, strokeWidth, innerRadius = 0) {
        const centerX = width / 2;
        const centerY = height / 2;
        
        // Shape 영역에 완전히 fit하도록 반지름 계산
        const availableWidth = width - strokeWidth;
        const availableHeight = height - strokeWidth;
        
        // 다각형이 완전히 들어갈 수 있는 최대 반지름 계산
        let maxRadiusX = availableWidth / 2;
        let maxRadiusY = availableHeight / 2;
        
        // 삼각형의 경우 특별 처리 - 정삼각형이 영역에 완전히 fit하도록
        if (sides === 3) {
            // 정삼각형의 높이는 (밑변 * √3) / 2
            // 영역에 fit하려면: 높이 = availableHeight, 밑변 = availableWidth
            // 반지름은 밑변의 1/3 (외접원의 반지름)
            const maxRadiusByHeight = (availableHeight * 2) / 3; // 높이 기준 반지름
            const maxRadiusByWidth = availableWidth / 2; // 너비 기준 반지름
            
            // 둘 중 작은 값 사용하여 영역을 벗어나지 않도록
            const fitRadius = Math.min(maxRadiusByHeight, maxRadiusByWidth);
            maxRadiusX = fitRadius;
            maxRadiusY = fitRadius;
        }
        
        const outerRadiusX = Math.max(0, maxRadiusX);
        const outerRadiusY = Math.max(0, maxRadiusY);
        const innerRadiusX = outerRadiusX * innerRadius;
        const innerRadiusY = outerRadiusY * innerRadius;
        
        const points = [];
        
        if (innerRadius > 0 && innerRadius !== undefined && innerRadius !== null) {
            // 별 모양: 외부 꼭짓점과 내부 꼭짓점 번갈아가며 생성
            for (let i = 0; i < sides * 2; i++) {
                const angle = (i * Math.PI / sides) - (Math.PI / 2); // -90도 회전 (12시 방향 시작)
                const isOuter = i % 2 === 0;
                const radiusX = isOuter ? outerRadiusX : innerRadiusX;
                const radiusY = isOuter ? outerRadiusY : innerRadiusY;
                const x = centerX + radiusX * Math.cos(angle);
                const y = centerY + radiusY * Math.sin(angle);
                points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
            }
        } else {
            // 기본 다각형: 외부 꼭짓점만
            for (let i = 0; i < sides; i++) {
                const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2); // -90도 회전 (12시 방향 시작)
                const x = centerX + outerRadiusX * Math.cos(angle);
                const y = centerY + outerRadiusY * Math.sin(angle);
                points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
            }
        }
        
        return points.join(' ');
    },

    // 모서리 둥글기가 적용된 다각형/별 path 생성
    generatePolygonPathPreview(width, height, sides, strokeWidth, cornerRadius, innerRadius = 0) {
        const centerX = width / 2;
        const centerY = height / 2;
        
        // Shape 영역에 완전히 fit하도록 반지름 계산
        const availableWidth = width - strokeWidth;
        const availableHeight = height - strokeWidth;
        
        // 다각형이 완전히 들어갈 수 있는 최대 반지름 계산
        let maxRadiusX = availableWidth / 2;
        let maxRadiusY = availableHeight / 2;
        
        // 삼각형의 경우 특별 처리 - 정삼각형이 영역에 완전히 fit하도록
        if (sides === 3) {
            // 정삼각형의 높이는 (밑변 * √3) / 2
            // 영역에 fit하려면: 높이 = availableHeight, 밑변 = availableWidth
            // 반지름은 밑변의 1/3 (외접원의 반지름)
            const maxRadiusByHeight = (availableHeight * 2) / 3; // 높이 기준 반지름
            const maxRadiusByWidth = availableWidth / 2; // 너비 기준 반지름
            
            // 둘 중 작은 값 사용하여 영역을 벗어나지 않도록
            const fitRadius = Math.min(maxRadiusByHeight, maxRadiusByWidth);
            maxRadiusX = fitRadius;
            maxRadiusY = fitRadius;
        }
        
        const outerRadiusX = Math.max(0, maxRadiusX);
        const outerRadiusY = Math.max(0, maxRadiusY);
        const innerRadiusX = outerRadiusX * innerRadius;
        const innerRadiusY = outerRadiusY * innerRadius;
        
        const vertices = [];
        
        if (innerRadius > 0 && innerRadius !== undefined && innerRadius !== null) {
            // 별 모양: 외부 꼭짓점과 내부 꼭짓점 번갈아가며 생성
            for (let i = 0; i < sides * 2; i++) {
                const angle = (i * Math.PI / sides) - (Math.PI / 2);
                const isOuter = i % 2 === 0;
                const radiusX = isOuter ? outerRadiusX : innerRadiusX;
                const radiusY = isOuter ? outerRadiusY : innerRadiusY;
                const x = centerX + radiusX * Math.cos(angle);
                const y = centerY + radiusY * Math.sin(angle);
                vertices.push({x, y});
            }
        } else {
            // 기본 다각형: 외부 꼭짓점만
            for (let i = 0; i < sides; i++) {
                const angle = (i * 2 * Math.PI / sides) - (Math.PI / 2);
                const x = centerX + outerRadiusX * Math.cos(angle);
                const y = centerY + outerRadiusY * Math.sin(angle);
                vertices.push({x, y});
            }
        }
        
        if (vertices.length < 3) return "";
        
        let pathData = "";
        
        for (let i = 0; i < vertices.length; i++) {
            const current = vertices[i];
            const next = vertices[(i + 1) % vertices.length];
            const prev = vertices[(i - 1 + vertices.length) % vertices.length];
            
            // 벡터 계산
            const dx1 = current.x - prev.x;
            const dy1 = current.y - prev.y;
            const dx2 = next.x - current.x;
            const dy2 = next.y - current.y;
            
            // 벡터 길이
            const len1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
            const len2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
            
            if (len1 === 0 || len2 === 0) continue;
            
            // 단위 벡터
            const ux1 = dx1 / len1;
            const uy1 = dy1 / len1;
            const ux2 = dx2 / len2;
            const uy2 = dy2 / len2;
            
            // 모서리 둥글기 적용 거리 계산
            const maxRadius = Math.min(len1, len2) / 2;
            const actualRadius = Math.min(cornerRadius, maxRadius);
            
            // 둥글기 시작/끝점
            const startX = current.x - ux1 * actualRadius;
            const startY = current.y - uy1 * actualRadius;
            const endX = current.x + ux2 * actualRadius;
            const endY = current.y + uy2 * actualRadius;
            
            if (i === 0) {
                pathData += `M ${startX.toFixed(2)} ${startY.toFixed(2)}`;
            } else {
                pathData += ` L ${startX.toFixed(2)} ${startY.toFixed(2)}`;
            }
            
            if (actualRadius > 0) {
                pathData += ` Q ${current.x.toFixed(2)} ${current.y.toFixed(2)} ${endX.toFixed(2)} ${endY.toFixed(2)}`;
            }
        }
        
        pathData += " Z";
        return pathData;
    },

    // 각 모서리별 둥글기가 적용된 사각형 path 생성
    generateRectanglePathPreview(x, y, width, height, tl, tr, bl, br) {
        // 모서리 둥글기가 너무 크면 제한
        const maxRadius = Math.min(width, height) / 2;
        tl = Math.min(tl, maxRadius);
        tr = Math.min(tr, maxRadius);
        bl = Math.min(bl, maxRadius);
        br = Math.min(br, maxRadius);

        return `M ${x + tl},${y}
                L ${x + width - tr},${y}
                ${tr > 0 ? `Q ${x + width},${y} ${x + width},${y + tr}` : `L ${x + width},${y}`}
                L ${x + width},${y + height - br}
                ${br > 0 ? `Q ${x + width},${y + height} ${x + width - br},${y + height}` : `L ${x + width},${y + height}`}
                L ${x + bl},${y + height}
                ${bl > 0 ? `Q ${x},${y + height} ${x},${y + height - bl}` : `L ${x},${y + height}`}
                L ${x},${y + tl}
                ${tl > 0 ? `Q ${x},${y} ${x + tl},${y}` : `L ${x},${y}`}
                Z`;
    },

    // 타원의 Arc, Pie, Donut path 생성 - 피그마 스타일
    generateEllipsePathPreview(cx, cy, radiusX, radiusY, startAngle, endAngle, innerRadiusRatio) {
        // 각도를 라디안으로 변환 (SVG는 12시 방향이 -90도)
        const startRad = ((startAngle - 90) * Math.PI) / 180;
        const endRad = ((endAngle - 90) * Math.PI) / 180;
        
        // 외부 타원의 시작점과 끝점
        const x1 = cx + radiusX * Math.cos(startRad);
        const y1 = cy + radiusY * Math.sin(startRad);
        const x2 = cx + radiusX * Math.cos(endRad);
        const y2 = cy + radiusY * Math.sin(endRad);
        
        // 호의 각도가 180도보다 큰지 확인
        const largeArcFlag = (endAngle - startAngle) % 360 > 180 ? 1 : 0;
        
        let pathData = "";
        
        if (innerRadiusRatio > 0) {
            // Donut 모양 (타원형)
            const innerRadiusX = radiusX * innerRadiusRatio;
            const innerRadiusY = radiusY * innerRadiusRatio;
            const ix1 = cx + innerRadiusX * Math.cos(startRad);
            const iy1 = cy + innerRadiusY * Math.sin(startRad);
            const ix2 = cx + innerRadiusX * Math.cos(endRad);
            const iy2 = cy + innerRadiusY * Math.sin(endRad);
            
            if ((endAngle - startAngle) % 360 === 0) {
                // 완전한 타원형 도넛
                pathData = `M ${cx + radiusX} ${cy} 
                           A ${radiusX} ${radiusY} 0 1 1 ${cx - radiusX} ${cy}
                           A ${radiusX} ${radiusY} 0 1 1 ${cx + radiusX} ${cy}
                           Z
                           M ${cx + innerRadiusX} ${cy}
                           A ${innerRadiusX} ${innerRadiusY} 0 1 0 ${cx - innerRadiusX} ${cy}
                           A ${innerRadiusX} ${innerRadiusY} 0 1 0 ${cx + innerRadiusX} ${cy}
                           Z`;
            } else {
                // 부채꼴 타원형 도넛
                pathData = `M ${x1} ${y1}
                           A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${x2} ${y2}
                           L ${ix2} ${iy2}
                           A ${innerRadiusX} ${innerRadiusY} 0 ${largeArcFlag} 0 ${ix1} ${iy1}
                           Z`;
            }
        } else {
            // Arc 또는 Pie (타원형)
            if ((endAngle - startAngle) % 360 === 0) {
                // 완전한 타원 (이 경우는 위에서 처리되지만 안전장치)
                pathData = `M ${cx + radiusX} ${cy} 
                           A ${radiusX} ${radiusY} 0 1 1 ${cx - radiusX} ${cy}
                           A ${radiusX} ${radiusY} 0 1 1 ${cx + radiusX} ${cy}
                           Z`;
            } else {
                // Pie 모양 (중심에서 시작, 타원형)
                pathData = `M ${cx} ${cy}
                           L ${x1} ${y1}
                           A ${radiusX} ${radiusY} 0 ${largeArcFlag} 1 ${x2} ${y2}
                           Z`;
            }
        }
        
        return pathData;
    },

    // CSS 그라데이션 문자열을 파싱하는 메서드
    parseCSSGradientPreview(cssGradient) {
        try {
            // linear-gradient 또는 radial-gradient 추출
            const isRadial = cssGradient.includes('radial-gradient');
            const type = isRadial ? 'radial' : 'linear';
            
            // 괄호 안의 내용 추출
            const match = cssGradient.match(/(?:linear|radial)-gradient\((.+)\)$/);
            if (!match) return null;
            
            const content = match[1];
            
            // 색상 stop들을 정확하게 분리하기 위해 더 정교한 방법 사용
            const colorStops = [];
            let angle = 180;
            
            // 각도 추출
            const angleMatch = content.match(/(\d+)deg/);
            if (angleMatch) {
                angle = parseInt(angleMatch[1]);
            }
            
            // HEX 색상 stop 추출 - #RRGGBB position% 또는 #RRGGBBAA position% 형태
            const hexMatches = content.matchAll(/#([0-9a-fA-F]{6}([0-9a-fA-F]{2})?)\s*(\d+)%/g);
            for (const match of hexMatches) {
                const hex = match[1];
                const position = parseInt(match[3]);
                
                // HEX를 RGB/RGBA로 변환
                let color;
                if (hex.length === 8) {
                    // 8자리 HEX (RRGGBBAA)
                    const r = parseInt(hex.slice(0, 2), 16);
                    const g = parseInt(hex.slice(2, 4), 16);
                    const b = parseInt(hex.slice(4, 6), 16);
                    const a = parseInt(hex.slice(6, 8), 16) / 255;
                    color = `rgba(${r}, ${g}, ${b}, ${a})`;
                } else {
                    // 6자리 HEX (RRGGBB)
                    const r = parseInt(hex.slice(0, 2), 16);
                    const g = parseInt(hex.slice(2, 4), 16);
                    const b = parseInt(hex.slice(4, 6), 16);
                    color = `rgb(${r}, ${g}, ${b})`;
                }
                
                colorStops.push({
                    color: color,
                    position: position
                });
            }
            
            // RGB/RGBA 색상 stop 추출 - rgba(r, g, b, a) position% 또는 rgb(r, g, b) position% 형태
            const colorMatches = content.matchAll(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)\s*(\d+)%/g);
            for (const match of colorMatches) {
                const r = match[1];
                const g = match[2];
                const b = match[3];
                const a = match[4]; // 알파값 (없을 수도 있음)
                const position = parseInt(match[5]);
                
                const color = a !== undefined ? `rgba(${r}, ${g}, ${b}, ${a})` : `rgb(${r}, ${g}, ${b})`;
                colorStops.push({
                    color: color,
                    position: position
                });
            }
            
            return { type, angle, stops: colorStops };
        } catch (error) {
            console.error('CSS gradient parsing error:', error);
            return null;
        }
    },

    // 유니크한 ID 생성 함수
    generateUniqueIdPreview(prefix = 'id') {
        const timestamp = Date.now();
        const random = Math.random().toString(36).substr(2, 9);
        const componentHash = this.model ? `${this.model.component_type}-${this.model.posx}-${this.model.posy}` : 'unknown';
        return `${prefix}-${componentHash}-${timestamp}-${random}`;
    },

    async loadSVGPreview(){
        if(!this.model?.svg_path || this.model.svg_path.length === 0){
            this.component.innerHTML = "";
            return;
        }

        try {
            let svgContent;
            
            if(this.model.svg_path.startsWith('data:image/svg+xml;base64,')){
                svgContent = atob(this.model.svg_path.split(',')[1]);
            } else if(this.model.svg_path.toLowerCase().startsWith("http")){
                const response = await fetch(this.model.svg_path);
                svgContent = await response.text();
            } else {
                const response = await fetch(this.model.svg_path);
                svgContent = await response.text();
            }

            if(this.model.svg_color_use){
                svgContent = this.applySVGColorsPreview(svgContent);
            }

            const svgElement = this.createSVGElementPreview(svgContent);
            this.component.innerHTML = "";
            this.component.appendChild(svgElement);

        } catch (error) {
            console.error("SVG 썸네일 로드 실패:", error);
            this.component.innerHTML = "";
        }
    },

    applySVGColorsPreview(svgContent) {
        let modifiedSvg = svgContent;
        
        if(this.model?.svg_color_use && this.model?.svg_fill_color){
            const colorType = this.model.svg_color_type || "color";
            
            if (colorType === "gradient") {
                // 그라데이션 처리
                const gradientId = `svg-gradient-${Date.now()}`;
                const parsedGradient = this.parseCSSGradientPreview(this.model.svg_fill_color);
                
                if (parsedGradient) {
                    const gradientType = parsedGradient.type === 'radial' ? 'radialGradient' : 'linearGradient';
                    let gradientAttrs = '';
                    
                    if (parsedGradient.type === 'radial') {
                        gradientAttrs = `cx="50%" cy="50%" r="50%"`;
                    } else {
                        // 선형 그라데이션 각도 처리
                        const angle = parsedGradient.angle || 0;
                        const radians = (angle * Math.PI) / 180;
                        const x1 = 50 + 50 * Math.cos(radians + Math.PI);
                        const y1 = 50 + 50 * Math.sin(radians + Math.PI);
                        const x2 = 50 + 50 * Math.cos(radians);
                        const y2 = 50 + 50 * Math.sin(radians);
                        gradientAttrs = `x1="${x1}%" y1="${y1}%" x2="${x2}%" y2="${y2}%"`;
                    }
                    
                    let gradientStops = '';
                    parsedGradient.stops.forEach(stop => {
                        gradientStops += `<stop offset="${stop.position}%" stop-color="${stop.color}"/>`;
                    });
                    
                    const gradientDef = `<defs><${gradientType} id="${gradientId}" ${gradientAttrs}>${gradientStops}</${gradientType}></defs>`;
                    
                    // SVG에 gradient defs 추가
                    modifiedSvg = modifiedSvg.replace(/<svg([^>]*)>/i, `<svg$1>${gradientDef}`);
                    
                    // fill 속성을 gradient URL로 변경
                    modifiedSvg = modifiedSvg.replace(/fill="[^"]*"/g, `fill="url(#${gradientId})"`);
                    modifiedSvg = modifiedSvg.replace(/style="fill:[^;"]*;?/g, `style="fill:url(#${gradientId});`);
                } else {
                    // 그라데이션 파싱 실패 시 단색으로 처리
                    modifiedSvg = modifiedSvg.replace(/fill="[^"]*"/g, `fill="${this.model.svg_fill_color}"`);
                    modifiedSvg = modifiedSvg.replace(/style="fill:[^;"]*;?/g, `style="fill:${this.model.svg_fill_color};`);
                }
            } else {
                // 단색 처리
                modifiedSvg = modifiedSvg.replace(/fill="[^"]*"/g, `fill="${this.model.svg_fill_color}"`);
                modifiedSvg = modifiedSvg.replace(/style="fill:[^;"]*;?/g, `style="fill:${this.model.svg_fill_color};`);
            }
        }
        
        return modifiedSvg;
    },

    createSVGElementPreview(svgContent) {
        const parser = new DOMParser();
        const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
        const svgElement = svgDoc.querySelector('svg');
        
        if(svgElement){
            svgElement.style.width = "100%";
            svgElement.style.height = "100%";
        }
        
        return svgElement;
    }

  },


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>